import { render, staticRenderFns } from "./projectResponsibleIdSelect.vue?vue&type=template&id=65f55b37&"
import script from "./projectResponsibleIdSelect.vue?vue&type=script&lang=js&"
export * from "./projectResponsibleIdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports